import addValidationMessage from '../utils/translation/addValidationMessage';

addValidationMessage('Core/minLengthValidator', 'minLength', {
  fr: 'Minimum {{minLength}} caractères',
  en: 'Minimum {{minLength}} characters',
});

const minLengthValidator = (value: string | number, { minLength }: { minLength: number}) => (
  (
    !value &&
    value !== 0
  ) ||
  String(value).length >= minLength
);

/**
 * @component
 * @visibleName minLengthValidator
 */
export default minLengthValidator;
